import { Flex } from '@mantine/core';
import { GroupedSuggestions } from 'src/common/components/markdown-editor/plugins/SuggestionTrackerPlugin';
import ShowMarkersToggle from './ShowMarkersToggle';
import SuggestionDropdown from './SuggestionDropdown';

type MarkersPanelProps = {
  suggestions: GroupedSuggestions;
  showMarkers: boolean;
  showToggle?: boolean;
  onShowMarkersChange: (value: boolean) => void;
};

export default function MarkersPanel({
  suggestions,
  showMarkers,
  showToggle = true,
  onShowMarkersChange,
}: MarkersPanelProps) {
  return (
    <Flex
      bg="blueGray.1"
      h={44}
      px="xs"
      py="xxs"
      style={{ borderRadius: 'var(--mantine-radius-xl)' }}
      justify="space-between"
      align="center"
      gap="md"
    >
      <Flex gap="xxs">
        {Object.keys(suggestions.default).length > 0 && (
          <SuggestionDropdown
            label="AI generated"
            bgColor="brand.1"
            suggestions={Object.values(suggestions.default)}
            disabled={!showMarkers}
          />
        )}
        {Object.keys(suggestions.note).length > 0 && (
          <SuggestionDropdown
            label="Exact content from meeting notes"
            bgColor="blueGray.2"
            suggestions={Object.values(suggestions.note)}
            disabled={!showMarkers}
          />
        )}
        {Object.keys(suggestions.inline).length > 0 && (
          <SuggestionDropdown
            label="Inline edits"
            bgColor="brand.1"
            suggestions={Object.values(suggestions.inline)}
            disabled={!showMarkers}
          />
        )}
        {Object.keys(suggestions.placeholder).length > 0 && (
          <SuggestionDropdown
            label="Adviser areas to review"
            bgColor="orange.2"
            suggestions={Object.values(suggestions.placeholder)}
            disabled={!showMarkers}
          />
        )}
      </Flex>
      {showToggle && <ShowMarkersToggle checked={showMarkers} onChange={onShowMarkersChange} />}
    </Flex>
  );
}
